exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".partner-referral-url{display:flex;justify-content:space-between;align-items:flex-start;background-color:rgba(238,238,238,.3);margin-top:15px}.partner-referral-url .referral-url-left{width:80%;word-wrap:break-word;color:#4a4a4a}.partner-referral-url .referral-url-right{padding:5px;cursor:pointer;background-color:rgba(238,238,238,.7)}", ""]);

// exports
